<div class="moedas-card-dep" (click)="closeMenu.emit(true); routerLink(departaments)">
   <div class="moedas-card-dep__container">
      <h3>{{ departaments?.displayName }}</h3>
      <img src="{{ departaments?.icon }}" alt="" />
   </div>
</div>
